import moment from 'moment';
import React from 'react';
import Tooltip from '../../components/Tooltip';
import { useIsSize } from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';

interface ResponsiveDateProps {
  date: string;
  render(options: { dateWithPreposition: string; condensed: boolean }): string;
}
const ResponsiveDate = ({ date, render }: ResponsiveDateProps) => {
  // we need to pass undefined in case of an empty string,
  // because moment('') is invalid
  const momentDate = moment(date || undefined);
  const isMobile = useIsSize(Sizes.SM);
  const fullDateWithPreposition = `at ${momentDate.format('lll')}`;

  if (!isMobile) {
    return (
      <>
        {render({
          condensed: false,
          dateWithPreposition: fullDateWithPreposition,
        })}
      </>
    );
  }

  const isSameYear = momentDate.isSame(moment(), 'year');
  const condensedDateWithPreposition = isSameYear
    ? `on ${momentDate.format('MMM D')}`
    : `in ${momentDate.format('YYYY')}`;

  return (
    <Tooltip
      trigger="click"
      placement="bottom"
      content={render({
        condensed: false,
        dateWithPreposition: fullDateWithPreposition,
      })}
    >
      <span>
        {render({
          condensed: true,
          dateWithPreposition: condensedDateWithPreposition,
        })}
      </span>
    </Tooltip>
  );
};

export default ResponsiveDate;
